document.addEventListener('click', function (e) {
  const card = e.target.closest('.js-iframe');
  if (!card) return;

  const iframeHTML = card.dataset.iframe;
  if (!iframeHTML) return;

  const textarea = document.createElement('textarea');
  textarea.innerHTML = iframeHTML;
  const decodedHTML = textarea.value;

  const lightbox = document.createElement('div');
  lightbox.className = 'c-lightbox';
  lightbox.innerHTML = `
    <div class="c-lightbox__content">
      <button class="c-lightbox__close" aria-label="Fermer">×</button>
      <div class="c-lightbox__video">${decodedHTML}</div>
    </div>
  `;

  document.body.appendChild(lightbox);

  const observer = new MutationObserver(() => {
    const allowButton = lightbox.querySelector('.tarteaucitronAllow');
    if (allowButton && !allowButton.dataset.eventAttached) {
      console.log('Bouton TAC trouvé, attachement de l\'événement');
      allowButton.dataset.eventAttached = 'true';

      allowButton.addEventListener('click', function(event) {
        event.preventDefault();
        console.log('Bouton cliqué !');

        if (typeof tarteaucitron !== 'undefined' && tarteaucitron.userInterface) {
          tarteaucitron.userInterface.respond(this, true);
        }
      });

      observer.disconnect();
    }
  });

  observer.observe(lightbox, { childList: true, subtree: true });

  if (typeof tarteaucitron !== 'undefined') {
    setTimeout(() => {
      tarteaucitron.job.push('vimeo');
      tarteaucitron.init(tarteaucitron.parameters);
    }, 50);
  }

  lightbox.addEventListener('click', function (ev) {
    if (
      ev.target.classList.contains('c-lightbox') ||
      ev.target.classList.contains('c-lightbox__close')
    ) {
      observer.disconnect();
      lightbox.remove();
    }
  });
});
